import * as React from 'react'

import { Button } from '@buffer-mono/popcorn'

import { AIAssistantContext } from '~publish/legacy/ai/components/AIAssistant/AIAssistant'
import { useContentGeneration } from '~publish/legacy/ai/hooks/useContentGeneration'
import {
  selectContentGenerationStatus,
  selectContentGenerationConfig,
} from '~publish/legacy/ai/state/slice'
import { useAppSelector } from '~publish/legacy/store'

import styles from './RetryButton.module.css'

import type { JSX } from 'react'

/**
 *
 */
function RetryButton({
  disabled,
  withBorder,
  children,
}: {
  disabled?: boolean
  withBorder?: boolean
  children: React.ReactNode
}): JSX.Element {
  const { channel } = React.useContext(AIAssistantContext)

  const { contentGenerationResults } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  const { prompt, action, tone } = useAppSelector((state) =>
    selectContentGenerationConfig(state),
  )

  const { generateContent } = useContentGeneration()

  const onClick = (): void => {
    if (!prompt || !action) return

    const previousResult = contentGenerationResults.length
      ? contentGenerationResults[0]
      : null

    void generateContent({
      prompt,
      action,
      tone,
      service: channel,
      previousResult,
      retry: true,
    })
  }

  return (
    <Button
      id="ai-assistant-retry-button"
      onClick={onClick}
      disabled={disabled}
      variant="tertiary"
      className={withBorder ? styles.withBorder : ''}
    >
      {children}
    </Button>
  )
}

export { RetryButton }
